export default __webpack_public_path__ + "maps-examples-runtime-add-line-1200-d94a233fbfa83e0c2724127e5b08709e.png";